import { toast } from "react-toastify";
class Utils {

    static showError(errMessage, autoClose, customId) {
        let toastOptions = {
            position: "top-right",
            autoClose: autoClose ? false : 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        };
        if (customId) {
            toastOptions.toastId = customId;
        }
        return toast.error(errMessage, toastOptions);
    }

    static showSuccess(message) {
        let toastOptions = {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        };
        return toast.success(message, toastOptions);
    }

    static showInfo(message) {
        let toastOptions = {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        };
        return toast.info(message, toastOptions);
    }

    static showLoading(message, autoClose, customId) {
        let toastOptions = {
            position: "top-right",
            autoClose: autoClose ? false : 5000,
            hideProgressBar: true,
            closeOnClick: false,
            closeButton: false,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
        };
        if (customId) {
            toastOptions.toastId = customId;
        }
        return toast.loading(message, toastOptions);
    }

    static showAnswer(type, answer, onCloseFunction) {
        let toastOptions = {
            position: "bottom-center",
            autoClose: false,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "light",
            onCLose: onCloseFunction
        }
        return toast(answer, toastOptions);
    }

    static dismissAllToast() {
        toast.dismiss();
    }

    static convertBytes(bytes, decimal = 2) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 Bytes';
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
        if (i === 0) return `${bytes} ${sizes[i]}`;
        return `${(bytes / (1024 ** i)).toFixed(decimal)} ${sizes[i]}`;
    }

    static mimeType(extension) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
        let mimeType = '';
        switch (extension) {
            case '.pdf':
                mimeType = 'application/pdf';
                break;
            case '.docx':
                mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                break;
            case '.ppt':
                mimeType = 'application/vnd.ms-powerpoint';
                break;
            case '.pptx':
                mimeType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
                break;
            case '.xlsx':
                mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                break;
            default:
                mimeType = 'text/plain';
                break;
        }
        return mimeType;
    }

    static base64ToImageFile(base64Url, fileName) {
        const base64String = atob(base64Url.split(',')[1]);
        let binaryData = new Uint8Array(base64String.length);

        for (let i = 0; i < base64String.length; i++) {
            binaryData[i] = base64String.charCodeAt(i);
        }

        const fileType = base64Url.split(';')[0].split(':')[1];
        const blob = new Blob([binaryData], { type: fileType });

        return new File([blob], fileName, { type: fileType });
    }

    static nl2br(text) {
        return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }

    static validateIsNumeric(value){
        let regex = new RegExp(/^\d+$/);
        return regex.test(value);
    }
}

export default Utils;
